// extracted by mini-css-extract-plugin
module.exports = {"modal":"ResetPasswordModal_modal__2FfmJ","btn":"ResetPasswordModal_btn__2D2ew","text":"ResetPasswordModal_text__Vn947"};